import { useEffect, useState } from 'react';
import { useAgreements } from '../../../hooks/api/useAgreements';

export const useMasterListJournalOptions = (open: boolean) => {
  const { fetchLicenses, fetchPublishingModels, fetchPublishers } =
    useAgreements();
  const [licenseOptions, setLicenseOptions] = useState<string[]>([]);
  const [publisherOptions, setPublisherOptions] = useState<string[]>([]);
  const [publishingModelOptions, setPublishingModelOptions] = useState<string[]>(
    []
  );

  useEffect(() => {
    if (!open) return;

    const fetchData = async () => {
      const selectableLicenses = await fetchLicenses();
      setLicenseOptions(
        selectableLicenses.filter((license) => license !== 'MULTIPLE')
      );
      setPublishingModelOptions(await fetchPublishingModels());
      setPublisherOptions(await fetchPublishers());
    };

    fetchData().catch((err) => console.log(err));
  }, [open, fetchLicenses, fetchPublishingModels, fetchPublishers]);

  return { licenseOptions, publisherOptions, publishingModelOptions };
};
